export default __webpack_public_path__ + "static/media/buy-medicaments.0a9320e8.svg";